<template>
  <div>
    <v-app-bar>
      <v-spacer></v-spacer>
      <v-menu v-if="$vuetify.breakpoint.smAndDown">
        <template v-slot:activator="{ on }">
          <v-icon
            class="mr-5"
            v-on="on"
            >mdi-dots-vertical</v-icon
          >
        </template>
        <v-list class="pt-0 pb-0">
          <v-list-item
            :style="tabOrders == 0 ? 'background-color:rgba(231, 231, 231, 0.6)' : null"
            @click="$route.name != 'articles' ? $router.push({ name: 'articles' }).catch(() => {}) : null"
            ><v-icon>mdi-home</v-icon>
          </v-list-item>
          <v-list-item
            :style="tabOrders == 1 ? 'background-color:rgba(231, 231, 231, 0.6)' : null"
            @click="$route.name != 'orders' ? $router.push({ name: 'orders' }).catch(() => {}) : null"
            >Pedidos</v-list-item
          >
        </v-list>
      </v-menu>
      <!-- Pestañas para pantallas más grandes -->
      <v-tabs
        v-else
        optional
        v-model="tabOrders"
        show-arrows
      >
        <!-- <v-spacer></v-spacer> -->
        <v-tab
          :style="tabOrders == 0 ? 'background-color:rgba(231, 231, 231, 0.6)' : null"
          value="0"
          @click="$route.name != 'articles' ? $router.push({ name: 'articles' }).catch(() => {}) : null"
        >
          <v-icon>mdi-home</v-icon>
        </v-tab>
        <v-tab
          :style="tabOrders == 1 ? 'background-color:rgba(231, 231, 231, 0.6)' : null"
          value="1"
          @click="$route.name != 'orders' ? $router.push({ name: 'orders' }).catch(() => {}) : null"
        >
          PEDIDOS
        </v-tab>
      </v-tabs>
    </v-app-bar>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      tabOrders: null,
    };
  },
  computed: {
    badgeContent() {
      return this.numberOfArticlesInCart()?.toString() || 0;
    },
  },

  methods: {
    ...mapActions("api", ["logout"]),
    ...mapGetters(["numberOfArticlesInCart"]),

    goToPage(goToPageName) {
      if ((goToPageName == "/" && this.$route.path != goToPageName) || !this.$route.path.includes(goToPageName)) {
        this.$router.push({ path: goToPageName == "/" ? goToPageName : "/" + goToPageName });
      }
    },
    setTab() {
      if (this.$route.name == "articles") {
        this.tabOrders = 0;
      } else if (this.$route.name == "orders") this.tabOrders = 1;
      // else if (this.$route.name == "parts") this.tab = 2;
      // else if (this.$route.name == 'configuracion' && this.tab != 1)
      //   this.tab = 1
      else this.tabOrders = null;
    },
  },
  created() {
    this.setTab();
  },
  watch: {
    $route() {
      this.setTab();
    },
  },
};
</script>
